import React, { useContext } from 'react';
import styled from 'styled-components';
import LocaleBlock from './LocaleBlock';
import Gallery from './Gallery';
import Vimeo from './Vimeo';
import { breakpoints } from '../styles/Variables';
import LocaleLink from './LocaleLink';
import LocaleContext from './LocaleContext';
import { tr } from '../utils/translations';

const TimelineItemStyles = styled.div`
  padding-bottom: 2rem;
  max-width: 54rem;
  margin: 0 auto;

  .title {
    text-align: center;
    font-size: var(--fsTitle2);
    margin-bottom: 1em;
  }

  .date {
    text-align: center;
    padding-bottom: 1em;
  }

  .block {
    margin-bottom: 2rem;
  }

  p {
    text-align: justify;
  }

  .cta {
    &:hover {
      background-color: black;
      color: var(--peach);
    }
  }

  @media (min-width: ${breakpoints.breakLg}) {
    h3 {
      text-align: center;
      font-size: var(--fsTitle2);
      margin: 1em 0;
    }
  }
`;

export default function TimelineItem({ timelineItem, imageMaxWidth }) {
  const [locale, setLocale] = useContext(LocaleContext);
  const { name, date, className, _rawContent, linkSlug } = timelineItem;
  return (
    <TimelineItemStyles className={className}>
      <div className="date">{date.split('-')[0]}</div>
      <div className="title">{name}</div>
      {_rawContent &&
        _rawContent.map((section, index) => {
          if (section._type === 'gallery') {
            return (
              <div key={section._key}>
                <Gallery
                  imageMaxWidth={imageMaxWidth}
                  images={section.images}
                  className={section.className}
                />
                <h3>{name}</h3>
              </div>
            );
          }
          if (section._type === 'vimeo') {
            return (
              <div key={section._key}>
                <Vimeo
                  vimeoID={section.vimeoID}
                  heightRatio={section.heightRatio}
                  controls
                  allowExpand
                />
                <h3>{name}</h3>
              </div>
            );
          }
          return <LocaleBlock content={section} key={`timeline_${index}`} />;
        })}
      {linkSlug && (
        <LocaleLink className="button cta" to={`/${linkSlug}`}>
          {tr('cta', 'viewMore', locale)}
        </LocaleLink>
      )}
    </TimelineItemStyles>
  );
}
